export const theme = {
    black: "#000",
    white: "#FFF",
    darkBrown: "#261d02",
    tan: "#F4F2EF",
    green: "#084935",
    grey: "#333333",
    greyBorder: "#707070"
}